import { useRecoilValue } from 'recoil';
import { StreamingMediaLibrary } from './StreamingMediaLibrary';
import { reportEvidenceState } from '../../../storage/reports';

type Props = {
  assetId: string;
};
export function StreamingMediaLibraryFromAsset({ assetId }: Readonly<Props>) {
  const states = useRecoilValue(reportEvidenceState(assetId));

  return <StreamingMediaLibrary states={states} />;
}